import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import routes from 'bundles/accomplishments/routes';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';

import 'css!bundles/global-styles/global-element-styles';

const appEnv = new Fluxible({
  component: routes,
});

appEnv.registerStore(ApplicationStore);
appEnv.registerStore(NaptimeStore);

export default appEnv;
